import { render, staticRenderFns } from "./CurvesList.vue?vue&type=template&id=3412b8dc&scoped=true"
import script from "./CurvesList.vue?vue&type=script&lang=ts"
export * from "./CurvesList.vue?vue&type=script&lang=ts"
import style0 from "./CurvesList.vue?vue&type=style&index=0&id=3412b8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412b8dc",
  null
  
)

export default component.exports